"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.newSavingsCelo = exports.ABI = void 0;
exports.ABI = [
    { inputs: [], stateMutability: "nonpayable", type: "constructor" },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "from", type: "address" },
            {
                indexed: false,
                internalType: "uint256",
                name: "celoAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "savingsAmount",
                type: "uint256",
            },
        ],
        name: "Deposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "from", type: "address" },
            { indexed: true, internalType: "address", name: "to", type: "address" },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousVoter",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newVoter",
                type: "address",
            },
        ],
        name: "VoterAuthorized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "from", type: "address" },
            {
                indexed: false,
                internalType: "uint256",
                name: "celoAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "savingsAmount",
                type: "uint256",
            },
        ],
        name: "WithdrawCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "from", type: "address" },
            {
                indexed: false,
                internalType: "uint256",
                name: "celoAmount",
                type: "uint256",
            },
        ],
        name: "WithdrawFinished",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "from", type: "address" },
            {
                indexed: false,
                internalType: "uint256",
                name: "savingsAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "celoAmount",
                type: "uint256",
            },
        ],
        name: "WithdrawStarted",
        type: "event",
    },
    {
        inputs: [],
        name: "_voter",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "owner", type: "address" },
            { internalType: "address", name: "spender", type: "address" },
        ],
        name: "allowance",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "approve",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "balanceOf",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "subtractedValue", type: "uint256" },
        ],
        name: "decreaseAllowance",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "addedValue", type: "uint256" },
        ],
        name: "increaseAllowance",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [{ internalType: "string", name: "", type: "string" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "recipient", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "transfer",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "sender", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "transferFrom",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "signer", type: "address" },
            { internalType: "uint8", name: "v", type: "uint8" },
            { internalType: "bytes32", name: "r", type: "bytes32" },
            { internalType: "bytes32", name: "s", type: "bytes32" },
        ],
        name: "authorizeVoteSigner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "voter", type: "address" }],
        name: "authorizeVoterProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "group", type: "address" },
            { internalType: "uint256", name: "value", type: "uint256" },
            { internalType: "address", name: "lesser", type: "address" },
            { internalType: "address", name: "greater", type: "address" },
        ],
        name: "proxyVote",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "group", type: "address" }],
        name: "proxyActivate",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "group", type: "address" },
            { internalType: "uint256", name: "value", type: "uint256" },
            { internalType: "address", name: "lesser", type: "address" },
            { internalType: "address", name: "greater", type: "address" },
            { internalType: "uint256", name: "index", type: "uint256" },
        ],
        name: "proxyRevokeActive",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "group", type: "address" },
            { internalType: "uint256", name: "value", type: "uint256" },
            { internalType: "address", name: "lesser", type: "address" },
            { internalType: "address", name: "greater", type: "address" },
            { internalType: "uint256", name: "index", type: "uint256" },
        ],
        name: "proxyRevokePending",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "proposalId", type: "uint256" },
            { internalType: "uint256", name: "index", type: "uint256" },
            {
                internalType: "enum Governance.VoteValue",
                name: "value",
                type: "uint8",
            },
        ],
        name: "proxyGovernanceVote",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "proposalId", type: "uint256" },
            { internalType: "uint256", name: "lesser", type: "uint256" },
            { internalType: "uint256", name: "greater", type: "uint256" },
        ],
        name: "proxyGovernanceUpvote",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "lesser", type: "uint256" },
            { internalType: "uint256", name: "greater", type: "uint256" },
        ],
        name: "proxyGovernanceRevokeUpvote",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "deposit",
        outputs: [{ internalType: "uint256", name: "toMint", type: "uint256" }],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "savingsAmount", type: "uint256" },
            {
                internalType: "address",
                name: "lesserAfterPendingRevoke",
                type: "address",
            },
            {
                internalType: "address",
                name: "greaterAfterPendingRevoke",
                type: "address",
            },
            {
                internalType: "address",
                name: "lesserAfterActiveRevoke",
                type: "address",
            },
            {
                internalType: "address",
                name: "greaterAfterActiveRevoke",
                type: "address",
            },
        ],
        name: "withdrawStart",
        outputs: [{ internalType: "uint256", name: "toWithdraw", type: "uint256" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "index", type: "uint256" },
            { internalType: "uint256", name: "indexGlobal", type: "uint256" },
        ],
        name: "withdrawFinish",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "index", type: "uint256" },
            { internalType: "uint256", name: "indexGlobal", type: "uint256" },
        ],
        name: "withdrawCancel",
        outputs: [{ internalType: "uint256", name: "toMint", type: "uint256" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "addr", type: "address" }],
        name: "pendingWithdrawals",
        outputs: [
            { internalType: "uint256[]", name: "", type: "uint256[]" },
            { internalType: "uint256[]", name: "", type: "uint256[]" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "uint256", name: "savingsAmount", type: "uint256" },
        ],
        name: "savingsToCELO",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "uint256", name: "celoAmount", type: "uint256" }],
        name: "celoToSavings",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
];
function newSavingsCelo(web3, address) {
    return new web3.eth.Contract(exports.ABI, address);
}
exports.newSavingsCelo = newSavingsCelo;
//# sourceMappingURL=SavingsCELO.js.map